import $ from "jquery";
export var ProjectJeSJeCherche = function () {
    $(document).ready(function () {
        // Vérifiez si le span n'est pas visible
        if ($('#error_1_id_type_de_projet_je_suis_je_cherche').is(':visible')) {
            $('.select2 .select2-selection[role=combobox]').css('border', 'none');
        }
    });
};
